module.exports = __webpack_public_path__ + "static/media/exo-latin-100.c5d03745.woff2";